
export default {
  // Auth-related translations
  "sign_in": "Entrar",
  "sign_up": "Cadastrar",
  "email_address": "Endereço de e-mail",
  "password": "Senha",
  "new_password": "Nova senha",
  "confirm_password": "Confirmar senha",
  "forgot_password": "Esqueceu a senha?",
  "reset_password": "Redefinir senha",
  "verification_code": "Código de verificação",
  "enter_verification_code": "Digite o código de 6 dígitos enviado para seu e-mail",
  "passwords_dont_match": "As senhas não coincidem",
  "password_too_short": "A senha deve ter pelo menos 8 caracteres",
  "invalid_code": "Código inválido ou expirado",
  "invalid_code_format": "O código de verificação deve ser um número de 6 dígitos",
  "password_reset_success": "Senha redefinida com sucesso",
  "send_reset_link": "Enviar senha temporária",
  "reset_link_sent": "Link de redefinição enviado para seu e-mail",
  "temp_password_sent": "Senha temporária enviada para seu e-mail",
  "reset_link_error": "Falha ao enviar link de redefinição. Tente novamente mais tarde.",
  "email_delivery_not_configured": "O envio de e-mails não está configurado. Entre em contato com o administrador.",
  "for_testing_use": "Para testes de desenvolvimento, você pode usar a CLI do Supabase ou o Painel para gerenciar usuários",
  "processing": "Processando...",
  "back": "Voltar",
  "verify_code": "Inserir código de verificação",
  "email_not_received": "Não recebeu o e-mail?",
  "leave_page_warning": "Você tem alterações não salvas. Tem certeza de que deseja sair desta página? Seu progresso de redefinição de senha será perdido.",
  "reset_link_required": "É necessário um link de redefinição válido para redefinir sua senha",
  // New rate limit messages
  "reset_rate_limit_exceeded": "Limite de taxa de e-mail excedido. Por favor, aguarde antes de tentar novamente.",
  "reset_rate_limit_message": "Por favor, aguarde {{seconds}} segundos antes de solicitar outra senha temporária.",
  "wait_before_retry": "Aguarde antes de tentar novamente",
  // Temporary password messages
  "password_reset_required": "Você precisa alterar sua senha para continuar",
  "temp_password_instructions": "Você está usando uma senha temporária. Por favor, crie uma nova senha.",

  // Username dialog related translations
  "create_username": "Criar Nome de Usuário",
  "username_required_description": "Por favor, crie um nome de usuário para continuar. Seu nome de usuário será visível para outros usuários.",
  "username": "Nome de Usuário",
  "username_placeholder": "Digite um nome de usuário",
  "username_requirements": "O nome de usuário só pode conter letras, números e sublinhados.",
  "save_username": "Salvar Nome de Usuário",
  "username_taken": "Este nome de usuário já está em uso. Por favor, tente outro.",
  "username_set_success": "Nome de usuário definido com sucesso!",
  "username_set_error": "Falha ao definir o nome de usuário. Por favor, tente novamente.",
  "auth_error": "Erro de autenticação. Por favor, tente entrar novamente."
};
